// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-24ac65ce]:after{content:normal}#main[data-v-24ac65ce]{min-height:auto}.ec-success-container[data-v-24ac65ce]{align-items:center;display:flex;flex-flow:column;margin-bottom:20px}.ec-success-grid[data-v-24ac65ce]{padding:10px}.ec-success-grid--text[data-v-24ac65ce]{width:100%;word-wrap:break-word;max-width:700px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
